import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import {SpinnerIcon} from '../../Icon';
import {FormattedMessage} from 'react-intl';
import React from 'react';

export default function EnvelopeSentMessagePopup() {
    return (
        <Dialog open={true}>
            <DialogContent style={{paddingBottom: 0}}>
                <div style={{marginRight: 10, marginBottom: 10}}>
                    <span className="font-italic text-success">
                        <FormattedMessage
                            id={'labels.ENVELOPE_SENT_UNDER_PROCESS'}/>...{' '}
                    </span>
                    <SpinnerIcon size="sm"/>
                </div>
            </DialogContent>
        </Dialog>
    )
}
